/* KozyNightmarez - lid text colour + font picker
   Adds "Text color" and "Text font" choices to the personalisation panel
   and shows them live on the "Design the top of your case" preview. */
(function(){
  if(location.pathname.indexOf('/products/')<0){ return; }

  var GFONTS='https://fonts.googleapis.com/css2?family=Bebas+Neue&family=Black+Ops+One&family=Cinzel:wght@700&family=Creepster&family=Dancing+Script:wght@700&family=Fredoka:wght@600&family=Great+Vibes&family=Metal+Mania&family=Montserrat:wght@700&family=Nosifer&family=Orbitron:wght@700&family=Permanent+Marker&family=Pirata+One&family=Special+Elite&family=UnifrakturMaguntia&display=swap';

  var FONTS=[
    ['','House Font (KozyNightmarez)','"KozyNightmarez", serif','700'],
    ['Classic Block','Classic Block','"Montserrat", sans-serif','700'],
    ['Bold Impact','Bold Impact','"Bebas Neue", sans-serif','400'],
    ['Elegant Serif','Elegant Serif','"Cinzel", serif','700'],
    ['Typewriter','Typewriter','"Special Elite", serif','400'],
    ['Handwritten Script','Handwritten Script','"Dancing Script", cursive','700'],
    ['Fancy Script','Fancy Script','"Great Vibes", cursive','400'],
    ['Marker','Marker','"Permanent Marker", cursive','400'],
    ['Old English','Old English','"UnifrakturMaguntia", serif','400'],
    ['Gothic Blackletter','Gothic Blackletter','"Pirata One", serif','400'],
    ['Horror Drip','Horror Drip','"Nosifer", cursive','400'],
    ['Spooky','Spooky','"Creepster", cursive','400'],
    ['Metal','Metal','"Metal Mania", cursive','400'],
    ['Sci-Fi','Sci-Fi','"Orbitron", sans-serif','700'],
    ['Rounded','Rounded','"Fredoka", sans-serif','600'],
    ['Stencil','Stencil','"Black Ops One", sans-serif','400']
  ];

  var COLORS=[
    ['','Let us pick (best contrast)','#f7f3ff'],
    ['Black','Black','#141414'],
    ['White','White','#f2f2f2'],
    ['Gray','Gray','#9aa0a6'],
    ['Red','Red','#d32f2f'],
    ['Orange','Orange','#f57c00'],
    ['Yellow','Yellow','#fdd835'],
    ['Green','Green','#2e7d32'],
    ['Blue','Blue','#1e88e5'],
    ['Purple','Purple','#8e24aa'],
    ['Pink','Pink','#ec407a'],
    ['Teal','Teal','#26a69a'],
    ['Brown / Tan','Brown / Tan','#8d6e63'],
    ['Glow in the Dark','Glow in the Dark','#c7ff9e'],
    ['Silver / Metallic','Silver / Metallic','#c0c4cc'],
    ['Gold / Metallic','Gold / Metallic','#d4af37']
  ];

  var CSS='#knrow-textcolor label{display:flex;align-items:center;gap:8px}'
        +'#kn-textcolor-swatch{display:inline-block;width:18px;height:18px;border-radius:50%;border:1px solid rgba(255,255,255,.45);flex:0 0 auto}'
        +'#knrow-textfont select{font-size:17px}'
        +'#knrow-textfont select option{font-size:17px}';

  var curColor='', curFont='';

  function once(){
    if(document.getElementById('kn-textstyle-assets')){ return; }
    var l=document.createElement('link');
    l.id='kn-textstyle-assets'; l.rel='stylesheet'; l.href=GFONTS;
    document.head.appendChild(l);
    var s=document.createElement('style'); s.textContent=CSS;
    document.head.appendChild(s);
  }

  function findFont(v){ for(var i=0;i<FONTS.length;i++){ if(FONTS[i][0]===v){ return FONTS[i]; } } return FONTS[0]; }
  function findColor(v){ for(var i=0;i<COLORS.length;i++){ if(COLORS[i][0]===v){ return COLORS[i]; } } return COLORS[0]; }

  function redraw(){
    var t=document.getElementById('kntxt');
    if(t){ t.dispatchEvent(new Event('input',{bubbles:true})); }
  }

  function patchCanvas(){
    var cv=document.getElementById('kncv'); if(!cv){ return; }
    var ctx=cv.getContext('2d'); if(!ctx || ctx.knStyled){ return; }
    var orig=ctx.fillText.bind(ctx);
    ctx.fillText=function(txt,x,y,mw){
      try{
        var f=findFont(curFont);
        if(f && f[0]){
          var m=String(this.font).match(/([0-9.]+)px/);
          this.font=f[3]+' '+(m?m[1]:'90')+'px '+f[2];
        }
        if(curColor){ this.fillStyle=findColor(curColor)[2]; }
      }catch(e){}
      return orig(txt,x,y,mw);
    };
    ctx.knStyled=true;
  }

  function buildRow(id,labelText,propName,options,decorate){
    var row=document.createElement('div');
    row.className='knrow'; row.id=id;
    var lab=document.createElement('label');
    lab.setAttribute('for',id+'-sel');
    lab.appendChild(document.createTextNode(labelText));
    var sel=document.createElement('select');
    sel.id=id+'-sel'; sel.name=propName;
    for(var i=0;i<options.length;i++){
      var o=document.createElement('option');
      o.value=options[i][0]; o.textContent=options[i][1];
      if(decorate){ decorate(o,options[i]); }
      sel.appendChild(o);
    }
    row.appendChild(lab); row.appendChild(sel);
    return row;
  }

  function sync(){
    var textRow=document.getElementById('knrow-text');
    var cRow=document.getElementById('knrow-textcolor');
    var fRow=document.getElementById('knrow-textfont');
    if(!textRow || !cRow || !fRow){ return; }
    var vis=textRow.offsetParent!==null && getComputedStyle(textRow).display!=='none';
    cRow.style.display=vis?'':'none';
    fRow.style.display=vis?'':'none';
    cRow.querySelector('select').disabled=!vis;
    fRow.querySelector('select').disabled=!vis;
  }

  function build(){
    var textRow=document.getElementById('knrow-text');
    if(!textRow || document.getElementById('knrow-textcolor')){ return; }
    var cRow=buildRow('knrow-textcolor','Text color','properties[Text color]',COLORS);
    var sw=document.createElement('span');
    sw.id='kn-textcolor-swatch';
    sw.style.background=findColor(curColor)[2];
    cRow.querySelector('label').appendChild(sw);
    var fRow=buildRow('knrow-textfont','Text font','properties[Text font]',FONTS,function(o,item){ o.style.fontFamily=item[2]; });
    textRow.parentNode.insertBefore(cRow,textRow.nextSibling);
    cRow.parentNode.insertBefore(fRow,cRow.nextSibling);
    var cSel=cRow.querySelector('select');
    var fSel=fRow.querySelector('select');
    cSel.value=curColor; fSel.value=curFont;
    fSel.style.fontFamily=findFont(curFont)[2];
    cSel.addEventListener('change',function(){
      curColor=cSel.value;
      sw.style.background=findColor(curColor)[2];
      redraw();
    });
    fSel.addEventListener('change',function(){
      curFont=fSel.value;
      fSel.style.fontFamily=findFont(curFont)[2];
      redraw();
    });
    sync(); redraw();
  }

  function tick(){ once(); patchCanvas(); build(); sync(); }

  tick();
  setInterval(tick,500);
  document.addEventListener('DOMContentLoaded',tick);
  if(document.fonts && document.fonts.ready){ document.fonts.ready.then(function(){ redraw(); }); }
})();
